/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NovitusBuyerDto } from './NovitusBuyerDto';
import {
    NovitusBuyerDtoFromJSON,
    NovitusBuyerDtoFromJSONTyped,
    NovitusBuyerDtoToJSON,
} from './NovitusBuyerDto';
import type { NovitusInvoiceInfoDto } from './NovitusInvoiceInfoDto';
import {
    NovitusInvoiceInfoDtoFromJSON,
    NovitusInvoiceInfoDtoFromJSONTyped,
    NovitusInvoiceInfoDtoToJSON,
} from './NovitusInvoiceInfoDto';
import type { NovitusDeviceControlDto } from './NovitusDeviceControlDto';
import {
    NovitusDeviceControlDtoFromJSON,
    NovitusDeviceControlDtoFromJSONTyped,
    NovitusDeviceControlDtoToJSON,
} from './NovitusDeviceControlDto';
import type { NovitusSystemInfoDto } from './NovitusSystemInfoDto';
import {
    NovitusSystemInfoDtoFromJSON,
    NovitusSystemInfoDtoFromJSONTyped,
    NovitusSystemInfoDtoToJSON,
} from './NovitusSystemInfoDto';
import type { NovitusInvoiceOptionsDto } from './NovitusInvoiceOptionsDto';
import {
    NovitusInvoiceOptionsDtoFromJSON,
    NovitusInvoiceOptionsDtoFromJSONTyped,
    NovitusInvoiceOptionsDtoToJSON,
} from './NovitusInvoiceOptionsDto';
import type { NovitusItemDto } from './NovitusItemDto';
import {
    NovitusItemDtoFromJSON,
    NovitusItemDtoFromJSONTyped,
    NovitusItemDtoToJSON,
} from './NovitusItemDto';
import type { NovitusPaymentDto } from './NovitusPaymentDto';
import {
    NovitusPaymentDtoFromJSON,
    NovitusPaymentDtoFromJSONTyped,
    NovitusPaymentDtoToJSON,
} from './NovitusPaymentDto';
import type { NovitusSummaryDto } from './NovitusSummaryDto';
import {
    NovitusSummaryDtoFromJSON,
    NovitusSummaryDtoFromJSONTyped,
    NovitusSummaryDtoToJSON,
} from './NovitusSummaryDto';

/**
 * 
 * @export
 * @interface NovitusInvoiceDto
 */
export interface NovitusInvoiceDto {
    /**
     * Metadane faktury
     * @type {NovitusInvoiceInfoDto}
     * @memberof NovitusInvoiceDto
     */
    info: NovitusInvoiceInfoDto;
    /**
     * Dane nabywcy/kupującego
     * @type {NovitusBuyerDto}
     * @memberof NovitusInvoiceDto
     */
    buyer: NovitusBuyerDto;
    /**
     * Informacje o odbiorcy (opcjonalnie)
     * @type {NovitusBuyerDto}
     * @memberof NovitusInvoiceDto
     */
    recipient?: NovitusBuyerDto;
    /**
     * Informacje o sprzedawcy (opcjonalnie)
     * @type {NovitusBuyerDto}
     * @memberof NovitusInvoiceDto
     */
    seller?: NovitusBuyerDto;
    /**
     * Opcje faktury
     * @type {NovitusInvoiceOptionsDto}
     * @memberof NovitusInvoiceDto
     */
    options?: NovitusInvoiceOptionsDto;
    /**
     * Tablica pozycji na dokumencie
     * @type {Array<NovitusItemDto>}
     * @memberof NovitusInvoiceDto
     */
    items: Array<NovitusItemDto>;
    /**
     * Podsumowanie faktury z sumami
     * @type {NovitusSummaryDto}
     * @memberof NovitusInvoiceDto
     */
    summary: NovitusSummaryDto;
    /**
     * Tablica sposobów płatności użytych na fakturze (1-16 pozycji)
     * @type {Array<NovitusPaymentDto>}
     * @memberof NovitusInvoiceDto
     */
    payments?: Array<NovitusPaymentDto>;
    /**
     * Dodatkowe linie wydruku
     * @type {Array<string>}
     * @memberof NovitusInvoiceDto
     */
    printout_lines?: Array<string>;
    /**
     * Dodatkowe informacje (opcjonalnie)
     * @type {Array<object>}
     * @memberof NovitusInvoiceDto
     */
    additional_info?: Array<object>;
    /**
     * Informacje systemowe (opcjonalnie)
     * @type {NovitusSystemInfoDto}
     * @memberof NovitusInvoiceDto
     */
    system_info?: NovitusSystemInfoDto;
    /**
     * Ustawienia sterowania urządzeniem (opcjonalnie)
     * @type {NovitusDeviceControlDto}
     * @memberof NovitusInvoiceDto
     */
    device_control?: NovitusDeviceControlDto;
}

/**
 * Check if a given object implements the NovitusInvoiceDto interface.
 */
export function instanceOfNovitusInvoiceDto(value: object): value is NovitusInvoiceDto {
    if (!('info' in value) || value['info'] === undefined) return false;
    if (!('buyer' in value) || value['buyer'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    return true;
}

export function NovitusInvoiceDtoFromJSON(json: any): NovitusInvoiceDto {
    return NovitusInvoiceDtoFromJSONTyped(json, false);
}

export function NovitusInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusInvoiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'info': NovitusInvoiceInfoDtoFromJSON(json['info']),
        'buyer': NovitusBuyerDtoFromJSON(json['buyer']),
        'recipient': json['recipient'] == null ? undefined : NovitusBuyerDtoFromJSON(json['recipient']),
        'seller': json['seller'] == null ? undefined : NovitusBuyerDtoFromJSON(json['seller']),
        'options': json['options'] == null ? undefined : NovitusInvoiceOptionsDtoFromJSON(json['options']),
        'items': ((json['items'] as Array<any>).map(NovitusItemDtoFromJSON)),
        'summary': NovitusSummaryDtoFromJSON(json['summary']),
        'payments': json['payments'] == null ? undefined : ((json['payments'] as Array<any>).map(NovitusPaymentDtoFromJSON)),
        'printout_lines': json['printout_lines'] == null ? undefined : json['printout_lines'],
        'additional_info': json['additional_info'] == null ? undefined : json['additional_info'],
        'system_info': json['system_info'] == null ? undefined : NovitusSystemInfoDtoFromJSON(json['system_info']),
        'device_control': json['device_control'] == null ? undefined : NovitusDeviceControlDtoFromJSON(json['device_control']),
    };
}

export function NovitusInvoiceDtoToJSON(value?: NovitusInvoiceDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'info': NovitusInvoiceInfoDtoToJSON(value['info']),
        'buyer': NovitusBuyerDtoToJSON(value['buyer']),
        'recipient': NovitusBuyerDtoToJSON(value['recipient']),
        'seller': NovitusBuyerDtoToJSON(value['seller']),
        'options': NovitusInvoiceOptionsDtoToJSON(value['options']),
        'items': ((value['items'] as Array<any>).map(NovitusItemDtoToJSON)),
        'summary': NovitusSummaryDtoToJSON(value['summary']),
        'payments': value['payments'] == null ? undefined : ((value['payments'] as Array<any>).map(NovitusPaymentDtoToJSON)),
        'printout_lines': value['printout_lines'],
        'additional_info': value['additional_info'],
        'system_info': NovitusSystemInfoDtoToJSON(value['system_info']),
        'device_control': NovitusDeviceControlDtoToJSON(value['device_control']),
    };
}

